import React, { Component } from "react";
import "./stylesheets/summary.css";
import HeaderBack from "../../../components/backoffice/headerback/HeaderBack";
import { getSummary } from "../../../modules/serverCall";
import "react-datepicker/dist/react-datepicker.css";
import Moment from "moment";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import jwt_decode from "jwt-decode";

export default class Summary extends Component {
  constructor(props) {
    super(props);
    var startDateData = Moment(new Date());
    var endDateData = Moment(startDateData).endOf("month");
    var startDateOtData = Moment(new Date()).subtract(30, "days");
    var lasttdateData = new Date(endDateData);
    var lasttdateValidity = Moment(new Date());
    this.state = {
      startDate: new Date(),
      startDateOtData: new Date(startDateOtData),
      lasttdateValidity: new Date(lasttdateValidity),
      // endDate:new Date(),
      // lasttdate:lasttdateData,
      editReq: false,
      editDetails: false,
      editCloser: false,
      showData: false,
      scroll: false,
      backdrop: false,
      placement: "end",
      saveBtn: false,
      lodingImagData: false,
      bgdetails: [],
      listStatusId: [
        { key: 1, value: "Request" },
        { key: 2, value: "BG" },
        { key: 3, value: "Surrender" },
        { key: 4, value: "Cancelled" },
      ],
      imageLoop: [],
      imageCount: 0,
      listTechnicians: [],
      listBranch: [],
      listBranchData: [],
      expanded: [0, 1],
      currnetmonthdata: new Date(),
      statusId: 1,
      selectedStatus: "Request",
      requestStatus: "10",
      image: require("../../../assets/images/blank-photo-image.png"),
      submitbtn: false,
      loading: false,
      showbtn: false,
      permissionArr: [],
      loadingData: "No data found",
      isError: {
        timeVali: "",
      },
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);

    const authToken = localStorage.getItem("auth");
    var decoded = jwt_decode(authToken);
    const userId = decoded.user_id;
    var editBtn = false;
    var saveBtn = false;
    var appBtn = false;
    this.handleInputFetch();
  }

  handleInputFetch = (event) => {
    var submitbtn = true;
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const authToken = localStorage.getItem("auth");
    var decoded = jwt_decode(authToken);
    const userId = decoded.user_id;
    var loadingData = "No data found";
    this.setState({
      loading: true,
      loadingData: "Loading",
    });
    var bgHomeArr = [];
    const statusId = this.state.selectedStatus;
    var sendData = {
      UserID: userId,
    };
    const fetchBgdetails = async () => {
      const responsebg = await getSummary(sendData);
      const datarespBg = responsebg;

      if (datarespBg.length > 0) {
        bgHomeArr = datarespBg;
        var totalBgValue = datarespBg.reduce(
          (a, v) => (a = a + v.TotalBGValue),
          0
        );
        var totalBgValuePre = datarespBg.reduce(
          (a, v) => (a = a + v.BGInPreClaim),
          0
        );
        var totalBgValueAfter = datarespBg.reduce(
          (a, v) => (a = a + v.BGAfterClaim),
          0
        );
        var totalBgValueClaim = datarespBg.reduce(
          (a, v) => (a = a + v.BGInClaim),
          0
        );
        var dataPush = {
          Bank: 0,
          TotalBGValue: totalBgValue,
          BGInPreClaim: totalBgValuePre,
          BGInClaim: totalBgValueClaim,
          BGAfterClaim: totalBgValueAfter,
          BankName: "Total",
        };
        bgHomeArr.push(dataPush);
      } else {
        loadingData = "No data found";
      }

      this.setState({
        bgdetails: bgHomeArr,
        loading: false,
        loadingData: loadingData,
      });
    };
    fetchBgdetails();
  };

  handleDropdown = (key, event) => {
    this.setState({
      selectedStatus: event.target.innerHTML,
      statusId: key,
      bgdetails: [],
      submitbtn: false,
      showData: false,
    });
  };

  handleDataChangeOther = (event) => {
    event.preventDefault();
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  render() {
    const addUserLogo = require("../../../assets/images/plus.png");
    const loadingImg = require("../../../assets/images/Hourglass.gif");
    const imageLoop = this.state.imageLoop;
    const uploadLogoImage = this.state.profileImage;

    var columns = [
      {
        dataField: "ReqID",
        text: "BANK",
        // filter: textFilter({className: 'filter_class_comp',placeholder: 'Search'}),
        sort: true,
        classes: "cursorPoint removePadding",
        headerClasses: "sch-headerName  cursorPoint",
      },
      {
        dataField: "BGTypeValue",
        text: "Total BG's  Value",
        // filter: textFilter({className: 'filter_class_comp',placeholder: 'Search'}),
        sort: true,
        classes: "removePadding",
        headerClasses: "cursorPoint sch-headerName",
      },
      {
        dataField: "BGNum",
        text: "BG's in pre claim period",
        // filter: textFilter({className: 'filter_class_comp',placeholder: 'Search'}),
        sort: true,
        classes: "removePadding",
        headerClasses: "cursorPoint sch-headerName",
      },
      {
        dataField: "BGDate",
        text: "BG's in Claim period",
        // filter: textFilter({className: 'filter_class_comp',placeholder: 'Search'}),
        sort: true,
        classes: "removePadding",
        headerClasses: "cursorPoint sch-headerName",
      },
      {
        dataField: "DivisionValue",
        text: "BG's after Claim period",
        // filter: textFilter({className: 'filter_class_comp',placeholder: 'Search'}),
        sort: true,
        classes: "removePadding",
        headerClasses: "cursorPoint sch-headerName",
      },
    ];

    var bgdetails = this.state.bgdetails;
    return (
      <div>
        <HeaderBack />
        <div className=" container jobfilter mb-4 mt-4">
          <div className="headerfilter-all">
            {/* <div className="filterbtn-sche">
              <Dropdown onSelect={this.handleDropdown}>
                <Dropdown.Toggle variant="warning" className="font_size DropClassBtn" id="dropdown-basic">
                  {this.state.selectedStatus}
                </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {listStatusId !== ''?
                    listStatusId.map((item, indexdata) => {
                    return (
                      <Dropdown.Item className="font_size" key={indexdata} eventKey={item.key}>
                        {item.value}
                      </Dropdown.Item>
                    );
                  })
                  : ''}
                  </Dropdown.Menu>
              </Dropdown>
            </div> */}
            {/* <div className="filterbtn">
              <Button variant="primary" className="font_size FetchClassBtn" onClick={this.handleInputFetch}>Fetch</Button>
            </div> */}
          </div>
        </div>
        <p className="NoteData">
          Note : Click on the number to get the list of BGs.
        </p>
        <div className="table-container-all">
          <Table bordered border="1">
            <thead>
              <tr>
                <th className="headerCls thWith">Bank</th>
                <th className="headerCls">Total BG's Value</th>
                <th className="headerCls">BG's in pre claim period</th>
                <th className="headerCls">BG's in Claim period</th>
                <th className="headerCls">BG's after Claim period</th>
              </tr>
            </thead>
            <tbody>
              {bgdetails.length > 0 ? (
                bgdetails.map((item, indexList) => {
                  return (
                    <tr key={indexList}>
                      <td>
                        <Link
                          className="cursorPoint linkClass"
                          to={"/home/&BankName=" + item.BankName}
                        >
                          {item.BankName}
                        </Link>
                      </td>
                      <td>
                        <Link
                          className="cursorPoint linkClass"
                          to={"/home/&BankName=" + item.BankName}
                        >
                          {item.TotalBGValue}
                        </Link>
                      </td>
                      <td>
                        <Link
                          className="cursorPoint linkClass"
                          to={
                            "/home/&BGInPreClaim=" +
                            item.BGInPreClaim.toString() +
                            "&BankName=" +
                            item.BankName
                          }
                        >
                          {item.BGInPreClaim}
                        </Link>
                      </td>
                      <td>
                        <Link
                          className="cursorPoint linkClass"
                          to={
                            "/home/&BGInClaim=" +
                            item.BGInClaim.toString() +
                            "&BankName=" +
                            item.BankName
                          }
                        >
                          {item.BGInClaim}
                        </Link>
                      </td>
                      <td>
                        <Link
                          className="cursorPoint linkClass"
                          to={
                            "/home/&BGAfterClaim=" +
                            item.BGAfterClaim.toString() +
                            "&BankName=" +
                            item.BankName
                          }
                        >
                          {item.BGAfterClaim}
                        </Link>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="6">{this.state.loadingData}</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        {this.state.lodingImagData === true ? (
          <span className="preloader">
            <img src={loadingImg} className="loaderImg" />
          </span>
        ) : (
          ""
        )}
      </div>
    );
  }
}
